import statesApi from "../../api/statesApi";

const state = { states: [] };

const actions = {
    createState({ commit }, state) {
        return new Promise((resolve, reject) => {
            statesApi.store(state)
                .then((response) => {
                    if (response.status === 201) {
                        commit("ADD_STATE", response.data);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    updateState({ commit }, data) {
        return new Promise((resolve, reject) => {
            statesApi
                .update(data)
                .then((response) => {
                    if (response.status === 200) {
                        commit("UPDATE_STATE", response.data.state);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

const mutations = {
    ADD_STATE: (state, state1) => state.states.unshift(state1),

    UPDATE_STATE: (state, states) => {
        const index = state.states.findIndex(
            (m) => m.id === states.id
        );

        if (index !== -1) {
            state.states.splice(index, 1, states);
        }
    },
};
export default { state, actions, mutations };